module.exports = __webpack_public_path__ + "static/media/format_size.e159c07b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/format_size.svg
// module id = 405
// module chunks = 1